<template>
  <div>
    <!-- 페이지 제목 -->
    <div v-if="isDispTitle">
      <div v-if="title.secure" style="position: absolute; left: calc(50% - 142px); top: 50px" class="mx-auto">
        <img src="@/assets/reservation/promotion-deco.png" width="300" />
      </div>
      <ReservationTitleLogo v-if="title.secure" :warning="true"> {{ title.name }} <br v-if="title.name" />{{ $t("page.reservation.secret-title") }} </ReservationTitleLogo>
      <TitleLogo v-else :title="$t('page.reservation.package-title')" :warning="false" />
    </div>

    <v-sheet v-if="!loading" style="padding-bottom: 100px; position: relative">
      <TipTapReader v-if="desc_options.content" class="tiptap_style pa-0" :options="desc_options" :key="descComponentKey + 'des'" style="min-height: 0px" />

      <div>
        <div v-if="!isIndividual" class="stepTitle px-8 mt-10" style="color: #8d8d8d">
          <span class="font-danjunghae" style="font-size: 34px">STEP.1</span>
          <span class="text-body-2 ml-2">{{ $t("page.reservation.lafia-reservation-step1") }}</span>
        </div>
        <div v-if="!selected_concept" class="d-flex justify-center mt-4" style="margin-bottom: 50px">
          <div class="conceptImageArea" @click="openSelectConcept">
            <span>{{ $t("button.selectConcept") }}</span>
          </div>
        </div>
        <div v-else class="d-flex flex-column align-center justify-center mt-4">
          <v-img
            :lazy-src="require('@/assets/placeholder.jpg')"
            :src="'/upload/concept/thumbnail_image/' + selected_concept.pattern_1_image"
            position="top center"
            aspect-ratio="0.83"
            max-width="180px"
            class="conceptImageAreaBorder"
            @click.stop="openSelectConcept"
            :class="promotionPriceInfo && promotionPriceInfo.conceptId ? 'imageNonSelectable' : 'imageSelectable'"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0 align-center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <span style="color: #8d8d8d; font-size: 14px; margin-top: 2px">[{{ getConceptTitle(selected_concept) }}]</span>
          <!-- <v-btn width="180px" class="conceptTitleBtn rounded-10 px-6 py-5 mt-2" depressed @click="openSelectConcept" :disabled="promotionPriceInfo && promotionPriceInfo.conceptId">
            {{ getConceptTitle(selected_concept) }}
          </v-btn> -->
        </div>
      </div>

      <div v-if="!isIndividual" class="stepTitle px-8 mt-6" style="color: #8d8d8d">
        <span class="font-danjunghae" style="font-size: 34px">STEP.2</span>
        <span class="text-body-2 ml-2">{{ $t("page.reservation.lafia-reservation-step2") }}</span>
      </div>
      <v-container style="margin-bottom: 100px" class="pa-0 mt-6">
        <div class="dateSelectBox mx-4 mx-md-8">
          <!-- 날짜 선택 -->
          <DateSelector
            :color="$vuetify.theme.currentTheme.primary"
            :width="330"
            class="mt-7 mb-4 mx-auto"
            @dateUpdated="dateUpdated_handler"
            :dateInit="date"
            :key="'DateSelector' + dateSelectComponentKey"
          />
          <!-- 시간 선택 -->
          <div v-if="!timeLoading" class="mx-auto mt-5" style="width: 328px">
            <div v-if="available_time_list.length > 0" class="d-flex justify-start flex-wrap" :key="timeSelectcomponentKey + 'time'">
              <v-btn
                v-for="item in available_time_list"
                :key="item"
                height="36"
                depressed
                class="timeSelectBtn rounded-10 px-3 mb-1 my-1"
                :class="{ enable: selected_time == item }"
                :disabled="already_reserved_time_list.includes(item)"
                @click="!already_reserved_time_list.includes(item) && selected_time != item ? (selected_time = item) : (selected_time = '')"
              >
                {{ item }}
              </v-btn>
            </div>
            <div v-else class="text-center mt-10 mb-8 text-body-1" style="color: #8d8d8d">
              {{ $t("page.reservation.lafia-no-available-time") }}
            </div>
          </div>

          <!-- 로딩 (시간 선택) -->
          <v-progress-circular v-if="timeLoading" indeterminate color="primary" size="40" style="height: 72px" class="d-flex mx-auto mt-8"></v-progress-circular>
        </div>
        <!-- 
        <div class="borderBox px-2 px-md-4 mx-4 mx-md-8 text-caption text-md-body-1 d-flex flex-column justify-center align-center">
          <div>{{ $t("page.reservation.lafia-product-guide-1") }}</div>
          <div>{{ $t("page.reservation.lafia-product-guide-2") }}</div>
          <div class="mt-4 warning--text">{{ $t("page.reservation.lafia-product-guide-3") }}</div>
        </div>
        -->
        <div style="margin-top: 10px; padding-bottom: 100px">
          <!-- 동적으로 products 배열을 렌더링 -->
          <template v-if="sortedProducts.length > 0">
            <component v-for="product in sortedProducts" :key="product.id" :is="getProductComponentName(product)" v-bind="getProductProps(product)" v-on="getProductEvents(product)" />
          </template>

          <!-- 옵션 상품 표시 -->
          <template v-if="optionProducts.length > 0">
            <!-- <div v-if="!isIndividual" class="stepTitle px-8 mt-8 mb-4" style="color: #8d8d8d">
              <span class="font-danjunghae" style="font-size: 34px">STEP.3</span>
              <span class="text-body-1 ml-2">{{ $t("page.reservation.lafia-reservation-step3") }}</span>
            </div> -->
            <div class="px-8 mt-8 mb-4 text-center" style="color: #545454">
              <div class="font-danjunghae" style="font-size: 34px">{{ $t("page.reservation.option-products-title") }}</div>
              <div class="text-body-1">{{ $t("page.reservation.lafia-reservation-step3") }}</div>
            </div>

            <OptionProductItem
              v-for="optionProduct in optionProducts"
              :key="'option-' + optionProduct.id"
              :product="optionProduct"
              :value="isOptionProductSelected(optionProduct.id)"
              @change="onOptionProductChange"
            />
          </template>
        </div>
      </v-container>

      <!-- 예약하기 하단 -->
      <v-sheet style="width: 100%; max-width: 580px; position: fixed; bottom: 72px; padding: 12px 24px; border-top: 1px solid #e0e0e0; z-index: 15; background-color: white">
        <div class="d-flex align-center justify-space-between">
          <!-- 결제하기 버튼 -->
          <v-btn
            large
            color="primary"
            style="font-size: 20px; min-width: 140px"
            class="rounded-10 darken-1"
            depressed
            :disabled="selected_time == '' || !persons || !selected_concept || !selectedProduct"
            @click="showRefundPolicyDialog()"
            :loading="pay_loading"
          >
            {{ $t("button.pay") }}
          </v-btn>

          <!-- 최종가격 -->
          <div class="text-right font-danjunghae" style="font-size: 28px; color: #5b4a62">
            <span class="text-body-1 grey--text text--darken-2 mr-2">{{ $t("page.reservation.total-amount") }}</span>
            {{ $toComma(computed_total_price) }}<span class="text-body-2 ml-1 grey--text text--darken-2">{{ $t("common.krw") }}</span>
          </div>
        </div>
      </v-sheet>
    </v-sheet>
    <v-sheet v-else class="text-center mt-14">
      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
    </v-sheet>
    <ConceptSelectDialog
      :visible="show_concept_select"
      @close="show_concept_select = false"
      @input="(e) => (show_concept_select = e)"
      :key="'concept' + show_concept_select_componentKey"
      @apply="(item) => (selected_concept = item)"
    />
    <NormalWarningDialog :msg="warning_dialog_messsage" @input="warningDialogInputEvent" @confirm="confirmDialog" :visible="show_warning_dialog" :key="'normal' + show_warning_dialog_componentKey" />

    <!-- <RefundPolicyGuideDialog
      @agree="agreeRefundPolicy"
      @cancel="show_refund_policy = false"
      @input="(e) => (show_refund_policy = e)"
      :visible="show_refund_policy"
      :key="refund_policy_dialog_componentKey"
    /> -->
    <CautionMesageDialog
      @agree="agreeRefundPolicy"
      @cancel="show_refund_policy = false"
      @input="(e) => (show_refund_policy = e)"
      :visible="show_refund_policy"
      :key="refund_policy_dialog_componentKey"
    />
  </div>
</template>
<script>
import { computed } from "vue"
import { mapActions, mapGetters, mapMutations, mapState } from "vuex"
import TitleLogo from "@/views/components/TitleLogo"
import DateSelector from "@/components/DateSelector"
import ReservationTitleLogo from "@/views/components/ReservationTitleLogo"
import LafiaOptionItem from "./components/LafiaOptionItem"
import LafiaOptionItemExt from "./components/LafiaOptionItemExt"
import LafiaOptionGroupItem from "./components/LafiaOptionGroupItem"
import ConceptSelectDialog from "@/views/components/ConceptSelectDialog"
import TipTapReader from "@/components/tiptap/Reader"
import { OperationTimeList, Holidays } from "@/constant"
import NormalWarningDialog from "@/views/components/NormalWarningDialog"
// import RefundPolicyGuideDialog from "@/views/components/RefundPolicyGuideDialog"
import payletterService from "@/api/payletter-service"
import CautionMesageDialog from "@/views/components/CautionMesageDialog"
import OptionProductItem from "./components/OptionProductItem"
import optionProductService from "@/api/optionProductService"
export default {
  components: {
    TitleLogo,
    DateSelector,
    ReservationTitleLogo,
    LafiaOptionItem,
    LafiaOptionItemExt,
    LafiaOptionGroupItem,
    ConceptSelectDialog,
    TipTapReader,
    NormalWarningDialog,
    // RefundPolicyGuideDialog,
    CautionMesageDialog,
    OptionProductItem,
  },

  provide() {
    return {
      promotion_info: computed(() => this.promotionPriceInfo),
      concepts: computed(() => this.selectableConceptList),
    }
  },
  data: () => ({
    loading: true,
    promotionPriceInfo: null,

    date: null,
    dateSelectComponentKey: 0,

    timeLoading: false,
    time_option_list: OperationTimeList,
    available_time_list: [],

    selected_time: "",
    timeSelectcomponentKey: 0,

    already_reserved_time_list: [],

    selectedProduct: null,

    descComponentKey: 0, //desc html
    //TipTap
    desc_options: {
      content: "",
      editable: false,
      supportImage: true,
      supportVideo: true,
    },

    tossPayments: null,
    reservation_dogin: false,

    //컨셉 선택
    show_concept_select_componentKey: 0,
    show_concept_select: false,
    selected_concept: null,

    persons: 1,

    //결제 진행중
    pay_loading: false,

    isFirstSkipDateWarningDialog: false,
    //warning dialog
    show_warning_dialog: false,
    warning_dialog_messsage: "",
    show_warning_dialog_componentKey: 0,

    show_refund_policy: false,
    refund_policy_dialog_componentKey: 0,

    conceptList: [],

    // 개별 운영시간 정보 추가
    individual_operation_time: null,
    // 현재 사용할 운영시간 정보 (개별 운영시간이 있으면 우선, 없으면 기본 운영시간 사용)
    current_operation_time: null,

    // 옵션 상품 관련
    optionProducts: [],
    selectedOptionProducts: [],
  }),

  watch: {
    lang() {
      console.log("watch lang")
      this.setDescription()
    },

    // date: {
    //   handler(newVal, oldVal) {
    //     // 날짜 변경시 promotion 정보 업데이트 - 날짜 유효성 여부 체크
    //     console.log("date handler", newVal.format("MM/DD"), oldVal && oldVal.format("MM/DD"))
    //     if (this.promotionPriceInfo) {
    //       if (newVal && !oldVal) {
    //         this.checkPromotionDate(this.promotionPriceInfo, true)
    //       } else if (newVal && oldVal && !newVal.isSame(oldVal, "day")) {
    //         this.checkPromotionDate(this.promotionPriceInfo)
    //       }
    //     }
    //   },
    //   immediate: false,
    // },
  },

  async mounted() {
    // payletter 관련 프로퍼티 초기화 (반응형 시스템 외부에서 관리)
    this.payletterWindow = null
    this.payletterWindowEventListener = null

    this.tossInit()

    try {
      const res = await this.getPromotionPrice({ promotionCode: this.getPromotionCode })
      this.promotionPriceInfo = res.promotionPrice

      // 개인 독립된 예약 promotion 인지 체크.
      if (this.promotionPriceInfo != null && this.promotionPriceInfo.isIndividual) {
        const individual_time_info = await this.loadIndividualOperationTime(this.getPromotionCode)
        console.log("개별 운영시간 사용:", individual_time_info)
        this.current_operation_time = individual_time_info
      } else {
        if (!this.operation_time) {
          const time_info = await this.loadOperationTime()
          if (!time_info) {
            alert(this.$t("alert.error_page"))
            this.$router.go(-1)
          }
        }
        this.current_operation_time = this.operation_time
      }
      this.conceptList = await this.loadConceptsAll()

      // 옵션 상품 로드
      await this.loadOptionProducts()

      if (this.$route.query.conceptId) {
        this.selected_concept = this.conceptList.find((e) => e.id == this.$route.query.conceptId)
      }

      let _promotionInfo = this.promotionPriceInfo
      if (_promotionInfo) {
        if (_promotionInfo.openAt && _promotionInfo.closeAt) {
          const openAt = this.dayjs(_promotionInfo.openAt)
          const closeAt = this.dayjs(_promotionInfo.closeAt)
          if (openAt && closeAt) {
            if (!this.dayjs().isBetween(openAt, closeAt, "day", "[]")) {
              alert(this.$t("alert.error_invalid_product_page"))
              this.$router.replace("/")
              return
            }
          }
        }

        //선택한 프로모션이 특정 컨셉용인지 확인
        if (_promotionInfo.conceptId) {
          this.selected_concept = this.conceptList.find((e) => e.id === _promotionInfo.conceptId)
        }
      }

      if (this.getTraveler) {
        try {
          const result = await this.$http.get(`/api/promotion/select/travelers/${this.getTraveler}`)
          console.log("travelerInfo", result)
          const travelerInfo = result.data
          if (travelerInfo) {
            if (travelerInfo.startAt && travelerInfo.endAt) {
              const startAt = this.dayjs(travelerInfo.startAt)
              const endAt = this.dayjs(travelerInfo.endAt)
              console.log("openAt", startAt)
              console.log("closeAt", endAt)
              console.log("dayjs()", this.dayjs())
              if (startAt && endAt) {
                if (!this.dayjs().isBetween(startAt, endAt, "day", "[]")) {
                  alert(this.$t("alert.error_invalid_product_page"))
                  this.$router.replace("/")
                  return
                }
              }
            }
          }
        } catch (e) {
          console.log(e)
          alert(this.$t("alert.error_invalid_product_page"))
          this.$router.replace("/")
          return
        }
      }
    } catch (e) {
      console.log(e)
      alert(this.$t("alert.error_page"))
      this.$router.go(-1)
    } finally {
      this.setDescription()
      this.loading = false
    }
  },
  computed: {
    ...mapState(["default_price", "lafia_user", "lang", "operation_time", "isSupportAbroadPay"]),
    ...mapGetters(["isKRW"]),

    getMaxAvailableRoom() {
      return 1 // 2 -> 3 -> 1
    },
    getPromotionCode() {
      return this.$route.query.event
    },
    getTraveler() {
      return this.$route.query.traveler
    },

    title() {
      if (this.promotionPriceInfo) {
        return { name: this.getTitle(this.promotionPriceInfo), secure: true }
      } else {
        return { name: "", secure: false }
      }
    },

    // 동적 상품 리스트를 정렬하여 반환
    sortedProducts() {
      var products = []
      try {
        if (this.promotionPriceInfo && this.promotionPriceInfo.products) {
          products = JSON.parse(this.promotionPriceInfo.products)
        } else {
          products = JSON.parse(this.default_price.products)
        }
        return products.sort((a, b) => a.order - b.order)
      } catch (e) {
        console.error("Failed to parse products:", e)
        return []
      }
    },

    // 최종 가격 계산
    computed_total_price() {
      let priceInfo = this.promotionPriceInfo ? this.promotionPriceInfo : this.default_price
      let totalPrice = 0

      // 기본 상품 가격 계산
      if (this.selectedProduct) {
        if (this.selectedProduct.type === "group") {
          totalPrice = Math.max(this.selectedProduct.price * this.persons, 0)
        } else {
          totalPrice = Math.max(this.selectedProduct.price, 0)
        }
      }

      // 옵션 상품 가격 추가
      this.selectedOptionProducts.forEach((optionProduct) => {
        totalPrice += Math.max(optionProduct.price, 0)
      })

      return totalPrice
    },

    selectableConceptList() {
      return this.conceptList.filter((e) => e.status === "노출")
    },

    isIndividual() {
      return this.promotionPriceInfo != null && this.promotionPriceInfo.isIndividual
    },

    isDispTitle() {
      return this.promotionPriceInfo != null && !this.promotionPriceInfo.isIndividual
    },

    isReverseOrder() {
      return this.promotionPriceInfo != null && this.promotionPriceInfo.isReverseOrder
    },
  },

  methods: {
    ...mapActions(["getPromotionPrice", "tossInit", "loadOperationTime", "loadConceptsAll", "cancelPayStatusUpdate", "loadIndividualOperationTime"]),

    getTitle(promotionPriceInfo) {
      let name = promotionPriceInfo && promotionPriceInfo.name
      return name ? `${name}` : ""
    },

    // 상품의 타이틀을 언어별로 가져오기
    getProductTitle(product) {
      if (!product || !product.title) return ""
      switch (this.lang) {
        case "en":
          return product.title.en || product.title.kr || ""
        case "jp":
          return product.title.jp || product.title.kr || ""
        default:
          return product.title.kr || ""
      }
    },

    // 상품의 서브타이틀을 언어별로 가져오기
    getProductSubtitle(product) {
      if (!product || !product.subtitle) return ""
      switch (this.lang) {
        case "jp":
          return product.subtitle.jp || product.subtitle.kr || ""
        case "en":
          return product.subtitle.en || product.subtitle.kr || ""
        default:
          return product.subtitle.kr || ""
      }
    },

    // 상품 타입에 따라 컴포넌트 이름 반환
    getProductComponentName(product) {
      if (product.type === "single") {
        return "LafiaOptionItem"
      } else {
        return "LafiaOptionGroupItem"
      }
    },

    // 상품에 대한 props 반환
    getProductProps(product) {
      const props = {
        src: {
          title: this.getProductTitle(product),
          subTitle: this.getProductSubtitle(product),
          price: product.price,
        },
        selected: this.selectedProduct?.id == product.id,
        maxGroupMemberSize: product.maxpersons ? product.maxpersons : 6,
      }

      return props
    },

    // 상품에 대한 이벤트 핸들러 반환
    getProductEvents(product) {
      // option3는 특별한 이벤트 처리
      if (product.type === "group") {
        return {
          click: (e) => this.selectProduct(product, e),
          changeCount: this.changeCount,
        }
      }

      // 기본 클릭 이벤트
      return {
        click: () => this.selectProduct(product),
      }
    },

    async dateUpdated_handler(date) {
      console.log("dateUpdated_handler")
      this.date = date.startOf("day")
      /*
      if(this.isReverseOrder) {
        this.selectOption("option1") // 솔로샷이 맨 처음.
      } else {
        this.selectOption("option3", 2) // 기본 선택 이 option1 -> option3 인원2
      }
      */

      // 해당 날짜의 영업 시간 확인
      this.available_time_list = this.getWorkDayTime(this.date)
      //날짜가 바뀐 경우 정보 초기화
      await this.checkOpenTime()
      if (this.promotionPriceInfo) {
        this.checkPromotionDate(this.promotionPriceInfo)
      }
    },
    // 선택된 날짜의 닫힌 시간 확인하기
    async checkOpenTime() {
      this.timeLoading = true
      // 선택한 시간 초기화
      this.selected_time = ""
      this.already_reserved_time_list = []

      let defaultExpireTime = null
      if (this.default_price && this.default_price.endAt) {
        defaultExpireTime = this.dayjs(this.default_price.endAt)
      }

      let autoEndAt = this.dayjs().add(3, "month").endOf("month")

      const diffMonth = this.date.startOf("month").diff(this.dayjs().startOf("month"), "month")
      // 지난 날짜의 경우
      if (this.date.isBefore(this.dayjs(), "date")) {
        // 전부 닫기
        this.already_reserved_time_list = this.time_option_list
        this.timeLoading = false
      }
      // 기본 가격에 따른 endAt 날짜에 따라 open 여부 결정
      else if (defaultExpireTime && this.date.isAfter(defaultExpireTime, "date")) {
        // 전부 닫기
        this.already_reserved_time_list = this.time_option_list
        this.timeLoading = false
      } else if (this.date.isAfter(autoEndAt, "date")) {
        // 전부 닫기
        this.already_reserved_time_list = this.time_option_list
        this.timeLoading = false
      } else if ((this.date.day() === 0 || this.date.day() === 6) && diffMonth > 2) {
        // 주말은 다음 달까지만 예약이 가능하고 그 이후는 전부 닫기 // 다음달(1) -> 다다음달(2)
        this.already_reserved_time_list = this.time_option_list
        this.timeLoading = false
      } else {
        console.log("checkOpenTime check date: ", this.date.format("YYYY-MM-DD"))
        this.already_reserved_time_list = []

        //연속 시간대 확인.
        try {
          await this.checkContinuouslyReservation()
        } catch (e) {
          console.log(e)
        }

        // 오늘 날짜일시 예약시간이 지났는지 확인
        this.TodayTimePassCheck()
        this.WorkTimeCheck(this.date)

        try {
          await this.todayTimeAvailableRoomCheck()
        } catch (e) {
          alert(this.$t("alert.error_page"))
          this.$router.go(-1)
        } finally {
          this.timeLoading = false
        }
      }
    },

    openSelectConcept() {
      if (this.promotionPriceInfo && this.promotionPriceInfo.conceptId) {
        return
      }
      this.show_concept_select = true
      this.show_concept_select_componentKey++
    },

    selectProduct(product, count) {
      console.log("selectProduct count", product, count)
      this.selectedProduct = product
      if (product.type === "group") {
        this.persons = count
      } else {
        this.persons = 1
      }
    },

    changeCount(value) {
      console.log("changeCount", value)
      if (this.selectedProduct.type === "group") {
        this.persons = value
      } else {
        this.persons = 1
      }
    },

    getConceptTitle(concept) {
      switch (this.lang) {
        case "en":
          return concept.title_en || concept.title
        case "jp":
          return concept.title_jp || concept.title
        default:
          return concept.title
      }
    },

    getWorkDayTime(date) {
      // current_operation_time을 사용하여 운영시간 확인
      if (!this.current_operation_time) {
        return []
      }

      const weekData = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"]
      const op_str = this.current_operation_time[weekData[date.day()]]

      return op_str.length
        ? op_str
            .split(",")
            .map((e) => e.trim())
            .filter((e) => e.length > 0)
            .sort()
        : []
    },

    WorkTimeCheck(date) {
      const workTimes = this.getWorkDayTime(date)

      if (this.isHoliday(date)) {
        this.already_reserved_time_list = this.time_option_list
      } else if (workTimes.length) {
        const offTime = this.time_option_list.filter((item) => !workTimes.includes(item))
        this.already_reserved_time_list.push(...offTime)
      } else {
        this.already_reserved_time_list = this.time_option_list
      }
    },

    isHoliday(date) {
      return Holidays.includes(date.format("YYYY-MM-DD"))
    },

    // 오늘 날짜일시 예약시간이 지났는지 확인
    TodayTimePassCheck() {
      // 오늘 날짜일 경우
      if (this.dayjs().isSame(this.date, "date")) {
        this.time_option_list.forEach((time) => {
          // 30 분 이전 까지만 예약 가능 // 30 -> 1분으로 수정
          const now = this.dayjs().add(1, "minute")

          let timeToCheck = this.dayjs()
            .hour(parseInt(time.split(":")[0]))
            .minute(parseInt(time.split(":")[1]))

          // 현재 시각이 지났을 경우
          if (timeToCheck.isBefore(now)) {
            this.already_reserved_time_list.push(time)
          }
        })
      }
    },
    // 오늘 날짜 예약 Full 시간대 check
    async todayTimeAvailableRoomCheck() {
      // 결제 전 기예약인원 재확인
      let reservedList = await this.$http
        .post("/api/reservation/select/specific/time/lafia/check", {
          params: {
            year: this.date.year(),
            month: this.date.month() + 1,
            day: this.date.date(),
            individual: this.isIndividual ? this.getPromotionCode : null,
          },
        })
        .then((res) => {
          return res.data.map((e) => ({
            time: e.time,
            count: Number(e.count),
          }))
        })

      console.log("todayTimeAvailableRoomCheck : ", this.isIndividual)

      if (this.isIndividual) {
        const secondIndividualPromotion = this.getPromotionCode.split("_")[0]

        // secondIndividualPromotion이 존재할 때만 parentReservedList 가져오기
        if (secondIndividualPromotion && secondIndividualPromotion.trim().length > 0) {
          try {
            const parentReservedList = await this.$http
              .post("/api/reservation/select/specific/time/lafia/indivisual_duplicate_time_check", {
                params: {
                  year: this.date.year(),
                  month: this.date.month() + 1,
                  day: this.date.date(),
                  individual: secondIndividualPromotion,
                },
              })
              .then((res) => {
                return res.data.map((e) => ({
                  time: e.time,
                  count: Number(e.count),
                }))
              })

            // parentReservedList를 reservedList에 합산
            parentReservedList.forEach((parentItem) => {
              const existingItem = reservedList.find((item) => item.time === parentItem.time)
              if (existingItem) {
                existingItem.count += parentItem.count
              } else {
                reservedList.push(parentItem)
              }
            })
          } catch (e) {
            console.log("todayTimeAvailableRoomCheck : parent reservation check error", e)
          }
        }
      }

      for (let item of reservedList) {
        if (item.count >= this.getMaxAvailableRoom) {
          this.already_reserved_time_list.push(item.time)
        }
      }
    },

    async checkContinuouslyReservation() {
      const reservedList = await this.$http.post("/api/reservation/select/specific/time/lafia/check", {
        params: {
          year: this.date.year(),
          month: this.date.month() + 1,
          day: this.date.date(),
          individual: this.isIndividual ? this.getPromotionCode : null,
        },
      })
      //console.log(reservedList)
      const myReservedLsit = reservedList.data.filter((e) => e.user_id === this.lafia_user.user_id)
      //console.log(myReservedLsit)

      // 오늘 날짜의 예약 시간대 리스트
      if (myReservedLsit.length > 0) {
        const timeList = myReservedLsit.map((e) => e.time)
        //console.log(timeList)

        timeList.forEach((reservedTime) => {
          const baseTime = this.dayjs(reservedTime, "HH:mm")

          this.time_option_list.forEach((operationTime) => {
            const opTime = this.dayjs(operationTime, "HH:mm")
            const diff = opTime.diff(baseTime, "minute")

            if (Math.abs(diff) <= 15) {
              // 예약된 시간과 15분 이내의 시간은 예약 불가능
              if (!this.already_reserved_time_list.includes(operationTime)) {
                this.already_reserved_time_list.push(operationTime)
              }
            }
          })
        })
      }
    },

    reservation: _.debounce(async function () {
      let orderId = Math.floor(Math.random() * 1000000000)

      if (!this.lafia_user.is_logined) {
        if (this.promotionPriceInfo && this.getPromotionCode) {
          this.$store.commit("ADD_PROMOTION_CODE", this.getPromotionCode)
        }
        alert(this.$t("alert.error_need_authentication"))

        // 현재 페이지의 모든 쿼리 파라미터를 로그인 페이지로 전달
        const callbackUrl = this.$route.fullPath
        this.$router.push({
          path: "/auth/login",
          query: { callbackUrl },
        })
        return
      }

      if (this.pay_loading) {
        alert(this.$t("alert.error_doing_pay_in_progress"))
        return
      }

      try {
        // 결제 진행중
        this.pay_loading = true

        // 오늘 날짜일시 예약시간이 지났는지 재확인
        await this.TodayTimePassCheck()

        // 중복 예약 체크
        const myReservedList = await this.$http.post("/api/reservation/select/specific/time/lafia/check/id", {
          params: {
            year: this.date.year(),
            month: this.date.month() + 1,
            day: this.date.date(),
            time: this.selected_time,
            individual: this.isIndividual ? this.getPromotionCode : null,
            user_id: this.lafia_user.user_id,
          },
        })

        if (myReservedList.data && myReservedList.data[0].count > 0) {
          alert(this.$t("alert.error_duplicate_reservation"))
          this.pay_loading = false // 결제 진행 중 취소
          this.$router.go(0)
          return
        }

        // 예약 전 다시한번 현재 시간대에 공간이 있는지 체크
        await this.todayTimeAvailableRoomCheck()

        // 시간 지났을 경우 종료
        if (this.already_reserved_time_list.includes(this.selected_time)) {
          alert("예약할 시각은 예약이 모두 완료되었습니다.")
          this.pay_loading = false // 결제 진행 중 취소
          this.$router.go(0)
          return
        }

        // 기본 상품 가격 계산
        let mainProductPrice = 0
        if (this.selectedProduct) {
          if (this.selectedProduct.type === "group") {
            mainProductPrice = Math.max(this.selectedProduct.price * this.persons, 0)
          } else {
            mainProductPrice = Math.max(this.selectedProduct.price, 0)
          }
        }

        let orderList = [
          {
            productName: "라피아 이용권",
            orderNum: this.persons,
            price: this.selectedProduct.price,
            totalPrice: this.persons * this.selectedProduct.price,
            finalPrice: mainProductPrice,
            discountCode: this.promotionPriceInfo && this.getPromotionCode ? this.getPromotionCode : null,
          },
        ]

        // 선택된 옵션 상품들을 orderList에 추가
        this.selectedOptionProducts.forEach((optionProduct) => {
          const optionTitle = this.getOptionProductTitleKr(optionProduct)
          orderList.push({
            productName: optionTitle || `옵션상품_${optionProduct.id}`,
            orderNum: 1,
            price: optionProduct.price,
            totalPrice: optionProduct.price,
            finalPrice: optionProduct.price,
            discountCode: null,
          })
        })

        // memo에 전달할 상품 정보 생성
        const productMemoInfo = {
          id: this.selectedProduct.id,
          price: this.selectedProduct.price,
          type: this.selectedProduct.type,
          freePicEditCount: this.selectedProduct.freePicEditCount,
        }

        const orderRes = await this.$http.post("/api/order/v2/order", {
          orderId: orderId.toString(),
          userId: this.lafia_user.user_id,
          orderDetailList: orderList,
          memo: JSON.stringify(productMemoInfo),
          type: "온라인이용권",
          options: JSON.stringify(
            this.selectedOptionProducts.map((optionProduct) => ({
              id: optionProduct.id,
              code: optionProduct.code,
              title: this.getOptionProductTitleKr(optionProduct),
              price: optionProduct.price,
            }))
          ),
        })

        let params = {
          order_id: orderRes.data.id,
          user_id: this.lafia_user.user_id,
          category: "라피아캐슬",
          maker: null,
          concept: this.selected_concept.title,
          year: this.date.year(),
          month: this.date.month() + 1,
          day: this.date.date(),
          time: this.selected_time,
          cloth: this.persons,
          clothPrice: this.computed_total_price,
          uncloth: 0,
          unclothPrice: 0,
          promotionCode: this.promotionPriceInfo && this.getPromotionCode ? this.getPromotionCode : null,
          packageCode: this.getTraveler,
          individual: this.isIndividual ? this.getPromotionCode : null,
        }

        // 시간예약 입력하기
        await this.$http.post("/api/reservation/v2/reserve", {
          ...params,
        })

        if (/*this.computed_total_price_original > 0 &&*/ this.computed_total_price === 0) {
          this.$router.replace("/toss/success?orderId=" + orderId + "&paymentKey=free&amount=" + this.computed_total_price)
        } else {
          let orderName = this.getOrderName()

          if (this.isSupportAbroadPay && !this.isKRW) {
            /*
            var popOption = "width=430, height=555, resizable=no, scrollbars=no, status=no;"
            var popGlOption = "width=800, height=600, resizable=no, scrollbars=no, status=no;"
            if (this.$vuetify.breakpoint.mobile) {
              this.payletterWindow = window.open("about:blank", "", popOption)
            } else {
              this.payletterWindow = window.open("about:blank", "", popGlOption)
            }

            if (!this.payletterWindow || this.payletterWindow.closed || typeof this.payletterWindow.closed == "undefined") {
              alert(this.$t("alert.error_popup_blocked"))
              this.pay_loading = false // 결제 진행 중 취소
              return
            }
              */

            if (this.payletterWindow) {
              const { online_url, mobile_url } = await payletterService.requestInternationalPay({
                storeorderno: orderId.toString(),
                amount: this.computed_total_price,
                currency: "KRW",
                payinfo: orderName,
                payeremail: this.lafia_user.email,
                payerid: this.lafia_user.user_id,
              })
              if (this.$vuetify.breakpoint.mobile) {
                this.payletterWindow.location.href = mobile_url
              } else {
                this.payletterWindow.location.href = online_url
              }

              this.payletterWindowEventListener = (event) => {
                if (event.data.message === "pay-completed") {
                  const payloadData = event.data.data
                  this.payletterEventUnregister()
                  const { retCode, orderNo, status } = payloadData
                  if (retCode == "0") {
                    // 성공
                    this.$router.push("/payletter/success?orderId=" + orderNo + "&amount=" + this.computed_total_price)
                  } else {
                    // 실패
                    this.$router.push("/fail?orderId=" + orderNo + "&message=" + status)
                  }
                }
              }
              window.addEventListener("message", this.payletterWindowEventListener)
            }
          } else {
            var tossPayments = TossPayments(process.env.VUE_APP_TOSS_PAYMENT_CLIENT_KEY)
            try {
              await tossPayments.requestPayment("카드", {
                amount: this.computed_total_price,
                orderId: orderId,
                orderName: orderName,
                customerName: this.lafia_user.name,
                customerEmail: this.lafia_user.email,
                successUrl: window.location.origin + "/toss/success",
                failUrl: window.location.origin + "/fail",
                useEscrow: false,
              })
            } catch (e) {
              console.error("토스페이먼츠 결제", error)
              // 사용자 취소, 결제실패
              this.cancelPayStatusUpdate({ order_id: orderRes.data.id, reason: "사용자취소" })
              this.pay_loading = false // 결제 진행 중 취소
            }
          }
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.pay_loading = false
      }
    }, 500),

    getOrderName() {
      let orderName = this.getProductTitle(this.selectedProduct)
      if (this.selectedProduct.type === "group") {
        const personText = this.lang === "ko" ? "명" : "people"
        orderName += " " + this.persons + personText
      }

      // 선택된 옵션 상품들의 이름 추가
      if (this.selectedOptionProducts.length > 0) {
        const optionNames = this.selectedOptionProducts
          .map((optionProduct) => {
            return this.getOptionProductTitleKr(optionProduct)
          })
          .filter((name) => name) // 빈 문자열 제거

        if (optionNames.length > 0) {
          orderName += " + " + optionNames.join(" + ")
        }
      }

      return orderName
    },

    setDescription() {
      let key = "content"

      this.desc_options.content = this.default_price[key]
      if (this.lang === "en" || this.lang === "jp") {
        let langkey = key + `_${this.lang}`
        if (this.default_price[langkey]) {
          this.desc_options.content = this.default_price[langkey]
        }
      }

      if (this.promotionPriceInfo && this.promotionPriceInfo[key]) {
        this.desc_options.content = this.promotionPriceInfo[key]
        if (this.lang === "en" || this.lang === "jp") {
          let langkey = key + `_${this.lang}`
          if (this.promotionPriceInfo[langkey]) {
            this.desc_options.content = this.promotionPriceInfo[langkey]
          }
        }
      }

      this.descComponentKey++
    },

    checkPromotionDate(promotion) {
      console.log("checkPromotionDate", promotion)
      // 해당 패키지가 예약 가능 아닌지 체크가 필요함.
      const startAt = this.dayjs(promotion.startAt)
      const endAt = this.dayjs(promotion.endAt)

      if (!this.date.isBetween(startAt, endAt, "day", "[]")) {
        if (this.isFirstSkipDateWarningDialog) {
          // 해당 프로 모션의 예약 기간이 아닙니다.
          if (this.dayjs().isAfter(endAt, "day")) {
            this.showWarningDialog("dialog.promotion-warning-end-guide")
          } else {
            this.showWarningDialog(this.$t("dialog.promotion-warning-date-guide", { startAt: startAt.format("YYYY/MM/DD"), endAt: endAt.format("YYYY/MM/DD") }))
          }
        } else {
          if (this.dayjs().isBefore(startAt)) {
            this.date = startAt.startOf("day")
          } else {
            this.date = this.dayjs().startOf("day")
          }
          this.dateSelectComponentKey++
          this.isFirstSkipDateWarningDialog = true
        }
      }
    },

    showWarningDialog(message) {
      this.warning_dialog_messsage = message
      this.show_warning_dialog = true
      this.show_warning_dialog_componentKey++
    },

    confirmDialog() {
      this.show_warning_dialog = false
      if (this.warning_dialog_messsage === "dialog.promotion-warning-end-guide") {
        this.$router.replace("/")
      } else {
        const product = this.promotionPriceInfo
        if (product) {
          const startAt = this.dayjs(product.startAt).startOf("day")
          if (this.dayjs().isBefore(startAt)) {
            this.date = startAt.startOf("day")
          } else {
            this.date = this.dayjs().startOf("day")
          }
          this.dateSelectComponentKey++
        }
      }
      this.warning_dialog_messsage = ""
      this.show_warning_dialog_componentKey++
    },

    warningDialogInputEvent(e) {
      !e && this.confirmDialog()
    },

    showRefundPolicyDialog() {
      // 로그인을 먼저 체크
      if (!this.lafia_user.is_logined) {
        if (this.getPromotionCode) {
          this.$store.commit("ADD_PROMOTION_CODE", this.getPromotionCode)
        }
        alert(this.$t("alert.error_need_authentication"))

        // 현재 페이지의 모든 쿼리 파라미터를 로그인 페이지로 전달
        const callbackUrl = this.$route.fullPath
        this.$router.push({
          path: "/auth/login",
          query: { callbackUrl },
        })
        return
      }

      this.refund_policy_dialog_componentKey++
      this.show_refund_policy = true
    },

    agreeRefundPolicy() {
      this.show_refund_policy = false

      // 기존 결제창이 열려있다면 닫기
      if (this.payletterWindow && !this.payletterWindow.closed) {
        console.log("기존 결제창을 닫습니다.")
        try {
          this.payletterWindow.close()
        } catch (e) {
          console.log("결제창 닫기 실패:", e)
        }
      }

      if (this.isSupportAbroadPay && !this.isKRW) {
        var popOption = "width=430, height=555, resizable=no, scrollbars=no, status=no;"
        var popGlOption = "width=800, height=600, resizable=no, scrollbars=no, status=no;"
        if (this.$vuetify.breakpoint.mobile) {
          this.payletterWindow = window.open("about:blank", "_blank", popOption)
        } else {
          this.payletterWindow = window.open("about:blank", "_blank", popGlOption)
        }

        if (!this.payletterWindow || this.payletterWindow.closed || typeof this.payletterWindow.closed == "undefined") {
          alert(this.$t("alert.error_popup_blocked"))
          this.pay_loading = false // 결제 진행 중 취소
          return
        }
      }
      this.reservation()
    },

    payletterEventUnregister() {
      console.log("payletterEventUnregister")
      if (this.payletterWindowEventListener) {
        window.removeEventListener("message", this.payletterWindowEventListener)
        this.payletterWindowEventListener = null
      }

      // 결제창이 열려있고 닫히지 않은 상태라면 닫기
      if (this.payletterWindow && !this.payletterWindow.closed) {
        try {
          this.payletterWindow.close()
        } catch (e) {
          console.log("결제창 닫기 실패:", e)
        }
      }
      this.payletterWindow = null
    },

    // 옵션 상품 로드
    async loadOptionProducts() {
      try {
        // promotionPriceInfo에서 option_products 가져오기
        const optionProductIds = this.promotionPriceInfo?.option_products

        if (optionProductIds) {
          // ID 문자열로 옵션 상품 정보 조회
          this.optionProducts = await optionProductService.getOptionProductsByIdString(optionProductIds)
        } else {
          this.optionProducts = []
        }
      } catch (error) {
        console.error("옵션 상품 로드 실패:", error)
        this.optionProducts = []
      }
    },

    // 옵션 상품 선택 여부 확인
    isOptionProductSelected(productId) {
      return this.selectedOptionProducts.some((p) => p.id === productId)
    },

    // 옵션 상품 선택/해제 처리
    onOptionProductChange({ product, selected }) {
      if (selected) {
        // 선택 추가
        if (!this.selectedOptionProducts.some((p) => p.id === product.id)) {
          this.selectedOptionProducts.push(product)
        }
      } else {
        // 선택 제거
        const index = this.selectedOptionProducts.findIndex((p) => p.id === product.id)
        if (index > -1) {
          this.selectedOptionProducts.splice(index, 1)
        }
      }
    },

    // 옵션 상품의 제목 가져오기
    getOptionProductTitle(product) {
      if (!product || !product.title) return ""

      // title이 문자열인 경우 JSON 파싱 시도
      if (typeof product.title === "string") {
        try {
          const parsed = JSON.parse(product.title)
          switch (this.lang) {
            case "en":
              return parsed.en || parsed.kr || ""
            case "jp":
              return parsed.jp || parsed.kr || ""
            default:
              return parsed.kr || ""
          }
        } catch {
          return product.title
        }
      }

      // title이 객체인 경우
      if (typeof product.title === "object") {
        switch (this.lang) {
          case "en":
            return product.title.en || product.title.kr || ""
          case "jp":
            return product.title.jp || product.title.kr || ""
          default:
            return product.title.kr || ""
        }
      }

      return ""
    },

    // 옵션 상품의 한글 제목만 가져오기
    getOptionProductTitleKr(product) {
      if (!product || !product.title) return ""

      // title이 문자열인 경우 JSON 파싱 시도
      if (typeof product.title === "string") {
        try {
          const parsed = JSON.parse(product.title)
          return parsed.kr || ""
        } catch {
          return product.title
        }
      }

      // title이 객체인 경우
      if (typeof product.title === "object") {
        return product.title.kr || ""
      }

      return ""
    },
  },

  beforeDestroy() {
    this.payletterEventUnregister()

    // 결제창이 열려있다면 닫기
    if (this.payletterWindow && !this.payletterWindow.closed) {
      this.payletterWindow.close()
    }
  },
}
</script>
<style scoped>
.timeSelectBtn {
  border: 1px solid lightgray;
  color: #515151;
  font-size: 16px;
  font-weight: normal;
  margin: 0 3px;
  background-color: white !important;
}

.enable {
  background: #ef7fab !important;
  color: white !important;
}

.dateSelectBox {
  border-radius: 10px;
  border: 4px solid #f5e4e4;
  margin: 10px;
  padding-bottom: 20px;
}

.borderBox {
  border-radius: 10px;
  border: 4px solid #f5e4e4;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 10px;
  padding-right: 10px;
}

::v-deep .conceptBtn.v-btn--disabled.v-btn--has-bg {
  cursor: not-allowed !important; /* 커서 스타일 */
  background-color: #ef7fab !important;
  color: white !important;
}

.conceptTitleBtn {
  border: 4px solid #f5e4e4 !important;
  background-color: white !important;
  color: #545454;
  border-radius: 1.5rem;
  font-size: 15px;
  font-weight: 400;
}

::v-deep .conceptTitleBtn.v-btn--disabled.v-btn--has-bg {
  cursor: not-allowed !important; /* 커서 스타일 */
  color: #545454 !important;
  background-color: white !important;
}

.stepTitle {
  border-bottom: 1px solid #c2bcba;
}

.conceptImageArea {
  border: 3px solid #f5e4e4;
  border-radius: 8px;
  width: 180px;
  height: 216px;
  cursor: pointer;
  color: #8d8d8d;
  display: flex;
  justify-content: center;
  align-items: center;
}

.conceptImageArea span {
  color: #8d8d8d;
  font-size: 14px;
}

.conceptImageArea:disabled {
  cursor: not-allowed;
}

.conceptImageAreaBorder {
  border: 3px solid #f5e4e4;
  border-radius: 8px;
}
.imageSelectable {
  cursor: pointer;
}

.imageNonSelectable {
  cursor: not-allowed;
}
</style>
